import React, { useEffect } from "react";
import InterestTable from "components/organisms/InterestTable";
import useInterest from "utils/clientAPIs/interest";
import InterestNewsRader from "components/templates/common/Interest/NewsRader/Index";
import DividerLine from "components/common/divider/line";
import InterestNewsRaderNews from "components/templates/common/Interest/NewsRader/News";
import { useInterestNewsRader } from "utils/clientAPIs/newsRader";
import { useInterestDiscuss } from "utils/clientAPIs/discuss";
import InterestNewsRaderReport from "components/templates/common/Interest/NewsRader/Repoprt";

function Interest({ isMobile }: { isMobile: boolean }) {
  const [
    session,
    update,
    userInfo,
    mutate,
    interestedAssets,
    interestMutate,
    interestValid,
  ] = useInterest();

  useEffect(() => {
    if (userInfo && userInfo.user && userInfo.user.interest) {
      interestMutate();
    }
  }, [userInfo, interestMutate]);
  const { data, isLoading, isError } = useInterestNewsRader();
  const [discussData, isValid] = useInterestDiscuss();

  return (
    <main className="min-w-[360px] h-auto bg-white max-w-[800px] w-screen">
      <InterestTable
        session={session}
        data={interestedAssets}
        isValid={interestValid}
        newsRaderData={data}
      />
      {/* {interestedAssets?.length > 0 && (
        <InterestNewsRader isMobile={isMobile} />
      )} */}
      {!interestValid && (
        <>
          <DividerLine size="md" />
          {(data?.length ?? 0) > 0 && <InterestNewsRaderNews data={data} />}
          {(discussData?.length ?? 0) > 0 && (
            <InterestNewsRaderReport data={discussData} />
          )}
        </>
      )}
    </main>
  );
}

export default Interest;
